module.exports = __webpack_public_path__ + "static/scale-model-of-six-flags-new-england-in-springfield-massachusetts-254d04321ec6e86c1eaf034b663019e9.png";